import { getFirstItemIdInMailListRow } from 'mini-mail-list-store/lib/utils/getFirstItemIdInMailListRow';
import { getMeetingClientItem } from 'mini-mail-list-store/lib/utils/getMeetingClientItem';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { lazyDeleteItemsWithoutConfirmDialog } from 'mini-mail-triage-actions';

export const deleteMeetingItemInMailListRow = (mailListRowId: string) => {
    const firstItemId = getFirstItemIdInMailListRow(mailListRowId);
    if (!getMeetingClientItem(firstItemId)) {
        return;
    }
    const item = getMailStore().items.get(firstItemId);
    item &&
        lazyDeleteItemsWithoutConfirmDialog({
            itemIds: [item.ItemId?.Id],
            parentFolderId: item.ParentFolderId?.Id,
        });
};
